import { createApiHandler } from './handler';

const orders = {
  apiClient: null,
  path: '/franchises/orders',

  setClient(apiClient) {
    this.apiClient = apiClient;
    this.initApiHandler();
  },

  initApiHandler() {
    Object.assign(this, createApiHandler(this.apiClient, this.path));
  },

  async getByBranch(id, params) {
    try {
      const queryParams = new URLSearchParams();
      params.forEach(param => {
        if (param.name && param.value) {
          queryParams.append(param.name, param.value);
        }
      });

      const response = await this.apiClient.get(`${this.path}/branch/${id}?${queryParams.toString()}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async processOrder(id, form) {
    try {
      const response = await this.apiClient.post(`${this.path}/process/${id}`, form);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async printMeal(id) {
    try {
      const response = await this.apiClient.post(`${this.path}/print/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async completeOrder(id) {
    try {
      const response = await this.apiClient.post(`${this.path}/complete/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async sendOrder(id, form) {
    try {
      const response = await this.apiClient.post(`${this.path}/send/${id}`, form);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async deliverOrder(id) {
    try {
      const response = await this.apiClient.post(`${this.path}/deliver/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async failedToSend(id, form) {
    try {
      const response = await this.apiClient.post(`${this.path}/failed-to-send/${id}`, form);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async cancelOrder(id) {
    try {
      const response = await this.apiClient.post(`${this.path}/cancel/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getShippingRates(id, form) {
    try {
      const response = await this.apiClient.post(`${this.path}/get-shipping-rates/${id}`, form);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async updateTrackingInfo(id, form) {
    try {
      const response = await this.apiClient.post(`${this.path}/update-tracking-info/${id}`, form);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default orders;
